import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';


const Profile = () => {
  const [profileData, setProfileData] = useState({
    userId: '',
    username: '',
    email: '',
    designation: '',
    photo: '',
  });

  useEffect(() => {
    const userData = {
      userId: sessionStorage.getItem('userId') || 'Not available',
      username: sessionStorage.getItem('username') || 'Not available',
      email: sessionStorage.getItem('email') || 'Not available',
      designation: sessionStorage.getItem('designation') || 'Not available',
      // Set default image if no photo is provided
      photo: sessionStorage.getItem('photo') || "https://cdn3.iconfinder.com/data/icons/avatars-flat/33/man_5-1024.png",    };
    setProfileData(userData);
  }, []);

  const profileCardStyle = {
    width: '100%',
    maxWidth: '600px',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    fontFamily: "'Roboto', sans-serif",
  };

  const profileHeaderStyle = {
    textAlign: 'center',
    marginBottom: '20px',
  };

  const profileContentStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
  };


  const profileInfoStyle = {
    display: 'flex',
    flexDirection: 'column',
  };

  const profileDetailsStyle = {
    marginTop: '20px',
  };

  const formLabelStyle = {
    fontSize: '0.9rem',
    marginBottom: '5px',
    color: '#555',
  };

  const formInputStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '1rem',
    backgroundColor: '#f9f9f9',
    color: '#333',
  };

  const formInputDisabledStyle = {
    ...formInputStyle,
    backgroundColor: '#f1f1f1',
    color: '#777',
  };

  const btnEditStyle = {
    width: '100%',
    padding: '10px',
    backgroundColor: '#4285f4',
    border: 'none',
    color: 'white',
    borderRadius: '5px',
    fontSize: '1rem',
    cursor: 'pointer',
    marginTop: '20px',
  };

  const btnEditHoverStyle = {
    backgroundColor: '#357ae8',
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={profileCardStyle}>
        <div style={profileHeaderStyle}>
        
        </div>
    
        <div style={profileContentStyle}>
          
          <div>
          <img
  src={sessionStorage.getItem("photo") || "https://png.pngtree.com/png-vector/20190710/ourlarge/pngtree-user-vector-avatar-png-image_1541962.jpg"}
  alt="Profile"
  className="me-3 border"
  style={{
    width: "150px",  // Set width for rectangle
    height: "140px",  // Set height for rectangle
    objectFit: "cover",  // Ensures the image fits the dimensions without distortion
    borderRadius: "10px",  // Smooth rounded corners
  }}
/>

          </div>
          
          <div style={profileInfoStyle}>
            
            <h4>{profileData.username}</h4>
            <p style={{ color: '#777' }}>{profileData.designation}</p>
            <p style={{ color: '#555' }}>{profileData.email}</p>
          </div>
        </div>
        <hr></hr>
        <div style={profileDetailsStyle}>
          <label htmlFor="User_ID" style={formLabelStyle}>USER ID:</label>
          <input
            id="User_ID"
            type="text"
            style={formInputDisabledStyle}
            value={profileData.userId}
            disabled
          />
          
          <label htmlFor="Username" style={formLabelStyle}>USERNAME:</label>
          <input
            id="Username"
            type="text"
            style={formInputDisabledStyle}
            value={profileData.username}
            disabled
          />

          <label htmlFor="Designation" style={formLabelStyle}>DESIGNATION:</label>
          <input
            id="Designation"
            type="text"
            style={formInputDisabledStyle}
            value={profileData.designation}
            disabled
          />

          <label htmlFor="Email_ID" style={formLabelStyle}>EMAIL ID:</label>
          <input
            id="Email_ID"
            type="text"
            style={formInputDisabledStyle}
            value={profileData.email}
            disabled
          />
        </div>
        <button
  style={btnEditStyle}
  onClick={() => {
    window.location.href = "/settings";
  }}
  onMouseOver={(e) => (e.target.style.backgroundColor = btnEditHoverStyle.backgroundColor)}
  onMouseOut={(e) => (e.target.style.backgroundColor = btnEditStyle.backgroundColor)}
>
  Edit
</button>


      </div>
    </div>
  );
};

export default Profile;
